import { Button, Popover } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CompactPicker, GithubPicker, SketchPicker } from 'react-color';
import { setIgnoreKeyCodeEvent } from '../../redux/board/reducer';
import './styles.scss';

const COLORS = [
  '#F9EBEA',
  '#FDEDEC',
  '#F5EEF8',
  '#F4ECF7',
  '#EAF2F8',
  '#EBF5FB',
  '#E8F8F5',
  '#EAFAF1',
  '#FEF9E7',
  '#FDF2E9',
  '#FBEEE6',
  '#FFFFFF',
  '#F2F4F4',
  '#EAECEE',
  '#F2D7D5',
  '#FADBD8',
  '#EBDEF0',
  '#E8DAEF',
  '#D4E6F1',
  '#D6EAF8',
  '#D1F2EB',
  '#D5F5E3',
  '#FCF3CF',
  '#FAE5D3',
  '#F6DDCC',
  '#F2F3F4',
  '#E5E8E8',
  '#D5D8DC',
  '#E6B0AA',
  '#F5B7B1',
  '#D7BDE2',
  '#D2B4DE',
  '#A9CCE3',
  '#AED6F1',
  '#A3E4D7',
  '#ABEBC6',
  '#F9E79F',
  '#F5CBA7',
  '#EDBB99',
  '#E5E7E9',
  '#CCD1D1',
  '#ABB2B9',
  '#D98880',
  '#F1948A',
  '#C39BD3',
  '#BB8FCE',
  '#7FB3D5',
  '#85C1E9',
  '#76D7C4',
  '#82E0AA',
  '#F7DC6F',
  '#F0B27A',
  '#E59866',
  '#D7DBDD',
  '#B2BABB',
  '#808B96',
  '#CD6155',
  '#EC7063',
  '#AF7AC5',
  '#A569BD',
  '#5499C7',
  '#5DADE2',
  '#48C9B0',
  '#58D68D',
  '#F4D03F',
  '#EB984E',
  '#DC7633',
  '#CACFD2',
  '#99A3A4',
  '#566573',
  '#C0392B',
  '#E74C3C',
  '#9B59B6',
  '#8E44AD',
  '#2980B9',
  '#3498DB',
  '#1ABC9C',
  '#2ECC71',
  '#F1C40F',
  '#E67E22',
  '#D35400',
  '#BDC3C7',
  '#7F8C8D',
  '#2C3E50',
  '#A93226',
  '#CB4335',
  '#884EA0',
  '#7D3C98',
  '#2471A3',
  '#2E86C1',
  '#17A589',
  '#28B463',
  '#D4AC0D',
  '#CA6F1E',
  '#BA4A00',
  '#A6ACAF',
  '#707B7C',
  '#273746',
  '#922B21',
  '#B03A2E',
  '#76448A',
  '#6C3483',
  '#1F618D',
  '#2874A6',
  '#148F77',
  '#239B56',
  '#B7950B',
  '#AF601A',
  '#A04000',
  '#909497',
  '#616A6B',
  '#212F3D',
  '#7B241C',
  '#943126',
  '#633974',
  '#5B2C6F',
  '#1A5276',
  '#21618C',
  '#117864',
  '#1D8348',
  '#9A7D0A',
  '#935116',
  '#873600',
  '#797D7F',
  '#515A5A',
  '#1C2833',
  '#641E16',
  '#78281F',
  '#512E5F',
  '#4A235A',
  '#154360',
  '#1B4F72',
  '#0E6251',
  '#186A3B',
  '#7D6608',
  '#784212',
  '#6E2C00',
  '#626567',
  '#424949',
  '#000000',
];

const ColorPicker = ({ onChange, type, color = 'white', icon, place = null }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const [hex, setHex] = useState(null);
  const handleVisibleChange = (v) => setVisible(v);

  const colorChange = (cl) => {
    const hexar = `${cl.hex}${Math.round(cl.rgb.a * 255).toString(16)}`;
    setHex(hexar);
  };
  useEffect(() => {
    if (hex) {
      onChange(hex, type);
    }
  }, [hex]);
  useEffect(() => {
    dispatch(setIgnoreKeyCodeEvent(visible));
  }, [visible]);
  const content =
    place !== 'settings' ? (
      <CompactPicker onChangeComplete={colorChange} />
    ) : (
      <div style={{ padding: '5px' }}>
        <SketchPicker width={200} color={color} onChangeComplete={colorChange} presetColors={[]} />
        <GithubPicker width={222} color={color} onChangeComplete={colorChange} triangle="hide" colors={COLORS} />
      </div>
    );
  return (
    <Popover zIndex={1071} content={content} trigger="click" open={visible} onOpenChange={handleVisibleChange}>
      {place !== 'settings' ? (
        <div>
          <Button
            type="text"
            size="small"
            style={{ height: '25px', marginTop: '3px' }}
            icon={<FontAwesomeIcon icon={icon} />}
          />
          <div
            style={{
              margin: '0 3px',
              width: '20px',
              height: '3px',
              background: color,
            }}
          />
        </div>
      ) : (
        <div className="swatch">
          <div className="color" style={{ background: color }} />
        </div>
      )}
    </Popover>
  );
};

export default ColorPicker;
